import type { BuddyMessage } from './companionApi';
/** Stable server identities prevent polling from duplicating optimistic local turns. */
export function mergeHistory(current: BuddyMessage[], incoming: BuddyMessage[]): BuddyMessage[] {
  if (!incoming.length) return current;
  const byId = new Map<string, BuddyMessage>();
  for (const m of current) if (m.id) byId.set(m.id, m);
  for (const m of incoming)
    if (m.id) {
      const old = byId.get(m.id);
      byId.set(m.id, {
        ...old,
        ...m,
        ...(old?.speech_token ? { speech_token: old.speech_token } : {}),
      });
    }
  return [...byId.values()].sort((a, b) => {
    if (!a.order_key) return b.order_key ? 1 : 0;
    if (!b.order_key) return -1;
    return a.order_key < b.order_key ? -1 : a.order_key > b.order_key ? 1 : 0;
  });
}
